import { makeStyles } from '@material-ui/core/styles'
import { headerHeight } from '../../../Constants'

export const wikiSideBarStyle = makeStyles((theme) => ({
  root: {
    height: `calc(100vh - ${headerHeight}px)`,
    background: theme.palette.common.white,
    borderLeftWidth: '1px',
    borderLeftColor: theme.palette.primary.main,
    borderLeftStyle: 'solid',
    overflowY: 'auto'
  },
  closeButton: {
    position: 'absolute',
    color: theme.palette.geoColors.headerText.main,
    right: 5,
    top: 0,
    zIndex: 1
  },
  closeButtonIcon: {
    color: theme.palette.geoColors.headerText.main
  },
  wrapper: {
    position: 'absolute',
    top: 0,
    right: 0,
    zIndex: 1000
  }
}))
